<template>
  <v-col cols="12" sm="12" md="12" lg="4" xl="4" class="checkout__summary">
    <div class="checkout__summary-sticky">
      <!-- ORDER SUMMARY -->
      <OrderSummary
        :selected-plan="selectedPlan"
        :stripe-checkout-service="stripeCheckoutService"
        :legal-entity="stripeCheckoutService.legalEntity"
        :checkout-type="checkoutType"
        @totalPriceChanged="onTotalPriceChanged($event)"
        @pricePlanChanged="$emit('pricePlanChanged', $event)"
      />
      <!-- ORDER SUMMARY END -->
      <!-- ORDER INFORMATION -->
      <CheckoutBenefitsList class="mt-7" />
      <!-- ORDER INFORMATION END -->
    </div>
  </v-col>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import OrderSummary from '@/components/PaymentForm/OrderSummary.vue';
import CheckoutBenefitsList from '@/components/PaymentForm/CheckoutBenefitsList.vue';
import StripeCheckoutService from '@/Services/Subscription/StripeCheckoutService';
import { Plan } from '@/classes/stripe';
@Component({
  components: {
    OrderSummary,
    CheckoutBenefitsList,
  },
})
export default class PaymentFormSidebar extends Vue {
  @Prop({ type: Plan })
  selectedPlan!: Plan;
  @Prop({ type: StripeCheckoutService })
  stripeCheckoutService!: StripeCheckoutService;
  @Prop({ type: String })
  checkoutType!: string;

  onTotalPriceChanged(price: any): void {
    this.$emit('totalPriceChanged', price);
  }
}
</script>
